import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    justifyContent: 'center',
    marginTop: theme.spacing(1.5),
  },
  chip: {
    cursor: 'pointer',
    fontWeight: 500,
    borderRadius: 20,
    border: `1px solid ${theme.palette.primary.dark}`,
    backgroundColor: 'transparent',
    color: theme.palette.common.black,
    padding: theme.spacing(0.5, 2),
    fontSize: 13,
    transition: 'background-color 0.15s, color 0.15s',
    '&:hover': {
      opacity: 0.7,
    },
  },
  chipActive: {
    border: `1px solid ${theme.palette.primary.contrastText}`,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  chipOthers: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.25),
  },
  expandIcon: {
    fontSize: 16,
  },
}))

export default useStyles
